import { bool, func, object, string, instanceOf, element } from 'prop-types';

export const personalizedSectionFetcher = {
    perseusName: string.isRequired,
    appName: string.isRequired,
    sectionName: string.isRequired,
    onFetchSucceeded: func,
    onFetchFailed: func,
    recommendationsParams: object,
    collectProps: object,
    shouldFetchCollections: bool,
    placeholder: instanceOf(element),
    rollouts: object,
    complianceData: object,
    onCardClick: func,
    withPolling: bool,
};
